/* eslint-disable no-unused-vars */

import { Channel, Topic } from "../../../constants";
import { call, takeLatest } from "redux-saga/effects";

import { ActionHandlerActionConstants } from "../../action-constants";
import { MessageBrokerUtils } from "../../../utils";
import { v4 as uuidv4 } from "uuid";

const ACTIONS = {
  deposit: "deposit",
  openPokerGame: "openPokerGame",
  openPokerHistory: "openPokerHistory"
};
const CHANNEL_TYPE = {
  email: "email",
  button: "button",
  banner: "banner",
  externalClick: "externalClick"
};

function* performDepositAction(action) {
  const ID = action.payload.buttonID;
  const funcProps = [
    {
      channel: Channel.NAVIGATION,
      topic: Topic.performAction,
      headers: { publisher: "unifiedclient" },
      data: {
        actionID: ACTIONS.deposit,
        launchInfo: {
          businessCorrelationID: uuidv4(),
          sequentialCorrelationID: 1,
          channel: {
            area: CHANNEL_TYPE.button,
            element: "Default",
            source: "Open Deposit"
          },
          appSpecificParameters: {},
          trigger: "userSelection",
          containerID: undefined,
          sourceAppID: "UO_UNIFIEDCLIENT",
          sourceAppVersion: "0.0.0",
          clientVersion: "0"
        },
        actionData: {}
      }
    }
  ];
  yield call(MessageBrokerUtils.publish, ...funcProps);
}

function* openPokerGame(action) {
  const ID = action.payload.buttonID;
  const blastPoolId = action.payload.poolID;
  const funcProps = [
    {
      channel: Channel.NAVIGATION,
      topic: Topic.performAction,
      headers: { publisher: "unifiedclient" },
      data: {
        actionID: ACTIONS.openPokerGame,
        launchInfo: {
          businessCorrelationID: uuidv4(),
          sequentialCorrelationID: 1,
          channel: {
            area: CHANNEL_TYPE.button,
            element: "Default",
            source: "Open Poker Game"
          },
          appSpecificParameters: {
            blastPoolId: parseInt(blastPoolId)
          },
          trigger: "userSelection",
          containerID: undefined,
          sourceAppID: "UO_UNIFIEDCLIENT",
          sourceAppVersion: "0.0.0",
          clientVersion: "0"
        },
        actionData: {}
      }
    }
  ];
  yield call(MessageBrokerUtils.publish, ...funcProps);
}

function* openPokerHistory(action) {
  const ID = action.payload.buttonID;
  const funcProps = [
    {
      channel: Channel.NAVIGATION,
      topic: Topic.performAction,
      headers: { publisher: "unifiedclient" },
      data: {
        actionID: ACTIONS.openPokerHistory,
        launchInfo: {
          businessCorrelationID: uuidv4(),
          sequentialCorrelationID: 1,
          channel: {
            area: CHANNEL_TYPE.button,
            element: "Default",
            source: "Open Poker History"
          },
          appSpecificParameters: {},
          trigger: "userSelection",
          containerID: undefined,
          sourceAppID: "UO_UNIFIEDCLIENT",
          sourceAppVersion: "0.0.0",
          clientVersion: "0"
        },
        actionData: {}
      }
    }
  ];
  yield call(MessageBrokerUtils.publish, ...funcProps);
}

export default [
  takeLatest(
    ActionHandlerActionConstants.PERFORM_DEPOSIT_ACTION,
    performDepositAction
  ),
  takeLatest(ActionHandlerActionConstants.OPEN_POKER_GAME, openPokerGame),
  takeLatest(ActionHandlerActionConstants.OPEN_POKER_HISTORY, openPokerHistory)
];
